import http from '../../../httpRequests.js';

export default {
    state(){
        return{
          
            url:'user/register',
            
           

        }
    }, 
  

    actions:{
        async signUp(context, payload){
        const response= await http.post(context.state.url, context.rootState.lang,payload);
        
       return response;
       

        }
    }
,
   
}